// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3_7fBuex71ZiPb-9xGcuNd","contractsList":"_2eb_Ux5y3JBFCOZueQopyw"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/contracts/EasinsureContractsList.scss
// module id = 1166
// module chunks = 0